import React from 'react'
import { PaginationItem as MuiPaginationItem, styled } from '@mui/material'

const sizes = {
    small: '2.6rem',
    medium: '3.2rem',
    large: '4rem',
}

const StyledPaginationItem = styled(MuiPaginationItem)(({ theme, size }) => ({
    borderRadius: '0px',
    margin: '0px !important',
    border: 'solid 1px #ebebed',
    color: '#5d6870',
    borderRight: 'none',
    fontSize: '1.4rem !important',
    userSelect: 'none',

    '&.MuiPaginationItem-ellipsis': {
        height: size ? sizes[size] : '3.2rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRight: '0',

        '&:hover': {
            border: 'solid 1px #ebebed',
            borderRight: '0',
            color: '#5d6870',
        },
    },
    '&:hover': {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.primary.main,
        border: `1px solid ${theme.palette.primary.main}`,
    },
    '&.Mui-selected': {
        backgroundColor: `${theme.palette.primary.main} !important`,
        border: 'none',
        color: theme.palette.common.white,
        '&:hover': {
            color: theme.palette.common.white,
        },
    },
}))

const PaginationItem = ({ size, ...rest }) => {
    return <StyledPaginationItem size={size} {...rest} />
}

export default PaginationItem
